import React from "react";

const Bannerheader = () => {
  return (
    <div>
      <div>
        <div className="cart-banner">
          <img
            src="/assets/img/ecommerce/banner/banner1.jpg"
            alt="Shopping Cart Banner"
            className="cart-banner-image"
            onError={(e) => {
              e.target.src =
                "https://via.placeholder.com/1200x250?text=Shopping+Cart";
            }}
          />
          <div className="cart-banner-overlay"></div>
        </div>
      </div>
    </div>
  );
};

export default Bannerheader;
